<div class="popup-warning" *ngIf="!data.trainings">
    <div class="img-warning">
        <img src="assets/warning.png">
    </div>
    <div class="pop-up-custom">
        <div class="w-100 text-center">
            <h1 mat-dialog-title>Warning !</h1>
            <div mat-dialog-content *ngIf="data.msgList == null">
                <p class="text-normal">{{data.msg}}</p>
            </div>
             <div mat-dialog-content *ngIf="data.msgList != null">
                <p class="text-normal" *ngFor="let msg of data.msgList">{{msg}}</p>
            </div>
            <div class="w-100">
                <button class="w-100 btn-primary" (click)="closeDialog()">OK</button>
            </div>
        </div>
    </div>
</div>



<div class="popup-warning" *ngIf="data.trainings">
    <div class="img-warning">
        <img src="assets/warning.png">
    </div>
    <div class="pop-up-custom">
        <div class="w-100 text-center">
            <h1 mat-dialog-title>You have {{data.trainings.length}} unfinished training.
            </h1>
            <div mat-dialog-content>
                <div *ngFor="let tr of data.trainings; let i = index">
                    <p class="text-normal">{{(i+1) + '. ' + tr.trainingName + ' - ' + tr.topic}}</p>
                </div>
            </div>
            <div class="w-100">
                <button class="w-100 btn-primary" (click)="closeDialog()">OK</button>
            </div>
        </div>
    </div>
</div>